import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
const config = {
  apiKey: "AIzaSyDZu7BW2ct7PMroGqXgBA5pDjYrfWRqd18",
  authDomain: "dateinvitesupport.firebaseapp.com",
  databaseURL: "https://dateinvitesupport.firebaseio.com/"
};

firebase.initializeApp(config);

export const auth = firebase.auth;
export const db = firebase.database();
